import { render } from "./ChatViewClinicUser.vue?vue&type=template&id=ace269d4&scoped=true&ts=true"
import script from "./ChatViewClinicUser.vue?vue&type=script&lang=ts"
export * from "./ChatViewClinicUser.vue?vue&type=script&lang=ts"

import "./ChatViewClinicUser.vue?vue&type=style&index=0&id=ace269d4&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace269d4"]])

export default __exports__